(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    function initCartSuggestionsSwiper() {
          document.querySelectorAll('.cart-suggestions-slider').forEach((slider) => {
            if (!slider.classList.contains('swiper-initialized')) {
              new Swiper(slider, {
                slidesPerView: 1.25,
                spaceBetween: 16,
                navigation: {
                  nextEl: '.upsell-button-next',
                  prevEl: '.upsell-button-prev',
                },
              });
            }
          });
        }

        document.addEventListener('DOMContentLoaded', function () {
          initCartSuggestionsSwiper();

          // Watch cart drawer for changes
          const cartDrawer = document.querySelector('.cart-drawer');
          if (cartDrawer) {
            const observer = new MutationObserver(() => {
              initCartSuggestionsSwiper();
            });
            observer.observe(cartDrawer, { childList: true, subtree: true });
          }
        });
  } catch(e) { console.error(e); }
})();

})();
